export const selectAreas = (state) => state.areas.areas;
export const selectAreasLoading = (state) => state.areas.loading;
export const selectAreasError = (state) => state.areas.error;
export const selectAreasPagination = (state) => state.areas.pagination;
export const selectCurrentArea = (state) => state.areas.currentArea;
export const selectAreasFilters = (state) => state.areas.filters;

